/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_List_SuccessInputs */

const es_tools_one_drive_list_success = /** @type {(inputs: Tools_One_Drive_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de OneDrive listada`)
};

const en_tools_one_drive_list_success = /** @type {(inputs: Tools_One_Drive_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OneDrive folder listed`)
};

/**
* | output |
* | --- |
* | "OneDrive folder listed" |
*
* @param {Tools_One_Drive_List_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_list_success = /** @type {((inputs?: Tools_One_Drive_List_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_List_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_list_success(inputs)
	return en_tools_one_drive_list_success(inputs)
});
export { tools_one_drive_list_success as "tools.one_drive.list_success" }